const matchhoroscope = {
  // Header Section
  "kundli_matching_service": "कुंडली मिलान सेवा",
  "match_your": "मिलाएँ अपनी",
  "horoscopes": "कुंडली",
  "for_perfect_union": "संपूर्ण मिलन के लिए",
  "match_horoscope_description": "प्रामाणिक वैदिक ज्योतिष के माध्यम से अपनी संगतता जानें। हमारी व्यापक कुंडली मिलान सेवा वैवाहिक सामंजस्य और रिश्ते की सफलता का निर्धारण करने के लिए 36 गुणों का विश्लेषण करती है।",

  // Form Fields
  "partner_1_details": "साथी 1 का विवरण",
  "partner_2_details": "साथी 2 का विवरण",
  "male_groom": "पुरुष/दूल्हा",
  "female_bride": "महिला/दुल्हन",
  "enter_groom_name": "दूल्हे का पूरा नाम दर्ज करें",
  "enter_bride_name": "दुल्हन का पूरा नाम दर्ज करें",
  "full_name": "पूरा नाम",
  "gender": "लिंग",
  "male": "पुरुष",
  "female": "महिला",
  "date_time_of_birth": "जन्म तिथि और समय",
  "place_of_birth": "जन्म स्थान",
  "enter_partner_name": "साथी का नाम दर्ज करें",
  "city_state_country": "शहर, राज्य, देश",
  "email_address": "ईमेल पता",
  "phone_number": "फोन नंबर",
  "enter_email_for_report": "विस्तृत रिपोर्ट के लिए अपना ईमेल दर्ज करें",
  "enter_phone": "अपना फोन नंबर दर्ज करें",
  "contact_details_info": "संपर्क विवरण देने से विस्तृत संगतता रिपोर्ट सीधे आपको प्राप्त होगी।",
  "service_pricing": "सेवा मूल्य",
  "complete_horoscope_matching": "पूर्ण कुंडली मिलान विश्लेषण",
  "one_time_payment_info": "विशेषज्ञ ज्योतिषियों द्वारा पूर्ण मिलान विश्लेषण हेतु एकमुश्त भुगतान",
  "detailed_compatibility_analysis": "विस्तृत संगतता विश्लेषण",
  "guna_milan_36_points": "गुण मिलान (36 अंकों की प्रणाली)",
  "manglik_dosha_analysis": "मांगलिक दोष विश्लेषण",
  "future_predictions_couple": "युगल के लिए भविष्यवाणी",
  "remedial_solutions": "उपाय एवं सुझाव",
  "pdf_report_download": "पीडीएफ रिपोर्ट डाउनलोड",
  "contact_information": "संपर्क जानकारी",

  // Actions
  "match_horoscopes_now": "अभी कुंडली मिलाएँ",
  "matching_horoscopes": "कुंडली मिलान जारी",
  "pay_and_match": "भुगतान करें और कुंडली मिलाएँ",
  "processing_payment": "भुगतान संसाधित हो रहा है...",
  "dd_mm_yyyy_time_format": "DD/MM/YYYY और HH:MM (12-घंटे) AM/PM में दर्ज करें",
  "am": "AM",
  "pm": "PM",
  "dd_placeholder": "DD",
  "mm_placeholder": "MM",
  "yyyy_placeholder": "YYYY",
  "hh_placeholder": "HH",

  // Results
  "compatibility_result": "संगतता परिणाम",
  "overall_compatibility": "कुल मिलाकर संगतता",
  "guna_milan_points": "गुण मिलान अंक",
  "match_status": "मिलान स्थिति",
  "excellent_match": "उत्तम मिलान",
  "good_match": "अच्छा मिलान",
  "average_match": "औसत मिलान",
  "detailed_guna_analysis": "विस्तृत गुण विश्लेषण",

  // Actions
  "download_detailed_report": "विस्तृत रिपोर्ट डाउनलोड करें",
  "consult_astrologer": "ज्योतिषी से परामर्श करें",
  "match_another_couple": "दूसरे युगल का मिलान करें",

  // Features
  "what_our_matching_includes": "हमारे मिलान में क्या शामिल है",
  "36_guna_analysis": "36 गुणों का विश्लेषण",
  "36_guna_analysis_desc": "सभी 36 संगतता बिंदुओं का पूर्ण आकलन",
  "love_compatibility": "आपका प्रेम जीवन",
  "love_compatibility_desc": "भावनात्मक और रोमांटिक सामंजस्य विश्लेषण",
  "family_harmony": "पारिवारिक सामंजस्य",
  "family_harmony_desc": "दीर्घकालिक संबंध स्थिरता का पूर्वानुमान",
  "manglik_dosha": "मांगलिक दोष जाँच",
  "manglik_dosha_desc": "दोष की पहचान और उसके उपाय",

  // Thank You Message
  "thank_you_submission": "आपके सबमिशन के लिए धन्यवाद!",
  "data_received_message": "आपका कुंडली मिलान अनुरोध सफलतापूर्वक प्राप्त हो गया है। हमारे अनुभवी ज्योतिषी दोनों कुंडलियों का सावधानीपूर्वक विश्लेषण करेंगे।",

  // Security & Timeline
  "your_data_secure": "आपका डेटा 100% सुरक्षित है",
  "data_security_message": "सभी व्यक्तिगत जानकारी एन्क्रिप्टेड और सुरक्षित है। हम आपके विवरण किसी तृतीय पक्ष से साझा नहीं करते।",
  "response_within_12_hours": "12 घंटे के भीतर उत्तर",
  "response_time_message": "हमारे विशेषज्ञ आपकी विस्तृत संगतता रिपोर्ट तैयार कर शीघ्र ही आपसे संपर्क करेंगे।",

  // Support
  "need_immediate_help": "तुरंत सहायता चाहिए?",
  "whatsapp_support": "व्हाट्सएप सपोर्ट",
  "processing_request": "आपका अनुरोध संसाधित हो रहा है",
  "back_to_home": "होम पर वापस जाएँ"
};

export default matchhoroscope;
